module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"label":{"gameset":"Game Set"},"processing":"Processing","draw":"Draw","won":"[{winner}] {name} Won"},"ja":{"label":{"gameset":"決着"},"processing":"進行中","draw":"引き分け","won":"[{winner}] {name} が勝利"}}')
  delete Component.options._Ctor
}
